const firebaseConfig = {
    apiKey: "AIzaSyAJzGvGkmb1w1cnm-9majAtQ2rRMe6w6RQ",
    authDomain: "car-mania-f1b76.firebaseapp.com",
    projectId: "car-mania-f1b76",
    storageBucket: "car-mania-f1b76.appspot.com",
    messagingSenderId: "583779582222",
    appId: "1:583779582222:web:32cebb8a0a62e510ac175f"
  };
  export default firebaseConfig;